import { Page } from "@/models"
import { AxiosRequestConfig } from "axios"
import type { MotivoDeCancelamentoDaVendaServiceAdapter } from '@/usecases/venda/adapter/MotivoDeCancelamentoDaVendaServiceAdapter'
import { Inject } from "inversify-props"
import { MotivoCancelamento } from "@/models/MotivoCancelamento"

export class FindMotivosDeCancelamentoDaVenda {
	@Inject('MotivoDeCancelamentoDaVendaServiceAdapter')
	private MotivoDeCancelamentoDaVendaServiceAdapter!: MotivoDeCancelamentoDaVendaServiceAdapter

	findAll = async (params?: any, config?: AxiosRequestConfig): Promise<Page<MotivoCancelamento>> =>
		this.MotivoDeCancelamentoDaVendaServiceAdapter.find(params, config)
}